import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import MuiFormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";
import classNames from "classnames";
export class FormControlLabel extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        className
      } = this.props;
      return /*#__PURE__*/React.createElement(MuiFormControlLabel, _extends({}, this.props, {
        className: classNames("prmbl-formControlLabel", className)
      }));
    });
  }
}
_defineProperty(FormControlLabel, "propTypes", {
  /**
   * The html id
   */
  id: PropTypes.string,
  /**
   * 	If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * 	A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * The text to be used in an enclosing label element.
   */
  label: PropTypes.string.isRequired,
  /**
   * The name of the component.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * **Signature:**
   * `function(event: object, checked: boolean) => void`
   * *event*: The event source of the callback. You can pull out the new value by
   * accessing `event.target.value`.
   * *checked*: The `checked` value of the switch
   */
  onChange: PropTypes.func,
  /**
   * The value of the component.
   */
  value: PropTypes.string,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: PropTypes.object
});
export default FormControlLabel;